import {
  Button,
  Container,
  FormControlLabel,
  Grid,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Table as MuiTable,
  Box,
  Stack,
  Checkbox,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Drawer,
  Chip,
  IconButton,
} from "@mui/material";
import React from "react";
import Iconify from "src/components/iconify";
import { WithAPICall } from "../utils/apiUtil";
import { cloneDeep, range, uniq } from "lodash";
import "react-virtualized/styles.css"; // only needs to be imported once
import { AutoSizer, Column, Table } from "react-virtualized";
import aravindMapping from "../utils/aravind-maping";

const NEW_ITEM = {
  searchTerm: "",
  action: "",
  results: [],
  selectedValues: [],
  category: "",
};

class ADataExplorer extends React.Component {
  state = {
    items: [NEW_ITEM],
    finalIds: [],
    selectedItemForDrawer: null,
    openDrawer: false,
  };

  handleAddNewItem = () => {
    const newItem = NEW_ITEM;
    this.setState({ items: [...this.state.items, newItem] });
  };

  handleItemChange = ({ index, searchTerm, action, results, category }) => {
    this.setState(
      (prevState) => {
        const newState = cloneDeep(prevState);
        if (searchTerm) {
          newState.items[index].searchTerm = searchTerm;
        }
        if (action) {
          newState.items[index].action = action;
        }
        if (results) {
          newState.items[index].results = results;
        }
        if (category) {
          newState.items[index].category = category;
        }
        return newState;
      },
      () => {
        if (category) {
          this.handleGetResults({ index });
        }
      }
    );
  };

  handleGetResults = async ({ index }) => {
    try {
      const searchTerm = this.state.items[index].searchTerm;
      const category = this.state.items[index].category;
      let res = await this.props.apiCallPost("/harley/aravind/searchByTerm", {
        searchTerm,
        category,
      });
      res.forEach((r) => (r.selected = false));
      this.handleItemChange({ index, results: res });
    } catch (error) {
      console.error("could not get results", error);
    }
  };

  handleSelectRow = ({ index, rowId, rowIndex }) => {
    this.setState((prevState) => {
      const newState = cloneDeep(prevState);
      if (newState.items[index].selectedValues.includes(rowId)) {
        newState.items[index].selectedValues = newState.items[
          index
        ].selectedValues.filter((v) => v !== rowId);
        newState.items[index].results[rowIndex].selected = false;
      } else {
        newState.items[index].selectedValues.push(rowId);
        newState.items[index].results[rowIndex].selected = true;
      }
      return newState;
    });
  };

  handleFilterItems = async () => {
    let finalIds = [];
    for (let i = 0; i < this.state.items.length; i++) {
      const item = this.state.items[i];
      if (item.action === "INCLUDE") {
        finalIds = uniq(finalIds.concat(item.selectedValues));
      } else if (item.action === "EXCLUDE") {
        finalIds = finalIds.filter((v) => !item.selectedValues.includes(v));
      }
    }
    try {
      const res = await this.props.apiCallPost("/harley/aravind/selectRows", {
        selectedIds: finalIds,
      });
      this.downloadCSV(res, "output.csv");
    } catch (error) {}
    this.setState({ finalIds });
  };

  handleDeleteItem = ({ index }) => {
    this.setState((prevState) => {
      const newState = cloneDeep(prevState);
      newState.items.splice(index, 1);
      return newState;
    });
  };

  handleLongSelect = ({ index, rowIndex }) => {
    this.setState((prevState) => {
      const newState = cloneDeep(prevState);
      let selectedValues = newState.items[index].selectedValues || [];
      newState.items[index].results.forEach((el, i) => {
        if (i <= rowIndex) {
          el.selected = true;
          selectedValues.push(el._id);
        }
      });
      newState.items[index].selectedValues = uniq(selectedValues);
      return newState;
    });
  };

  downloadCSV = (jsonData, filename) => {
    // Convert JSON to CSV format
    const csvRows = [];
    const headers = Object.keys(jsonData[0]); // Assuming consistent structure
    csvRows.push(headers.join(",")); // Add header row

    for (const row of jsonData) {
      const values = headers.map((header) => {
        const escapedValue = `${row[header]}`.replace(/"/g, '""'); // Escape quotes
        return `"${escapedValue}"`;
      });
      csvRows.push(values.join(","));
    }

    const csvString = csvRows.join("\n");

    // Create a download link and trigger the download
    const downloadLink = document.createElement("a");
    downloadLink.href =
      "data:text/csv;charset=utf-8," + encodeURIComponent(csvString);
    downloadLink.target = "_blank";
    downloadLink.download = filename;
    downloadLink.click();
  };

  render() {
    return (
      <Container style={{ maxWidth: 50000 }}>
        <Drawer
          PaperProps={{
            sx: { width: "60%" },
          }}
          open={this.state.openDrawer}
          onClose={() => {
            this.setState({ openDrawer: false });
          }}
        >
          <MuiTable aria-label="simple table" sx={{ padding: "1rem" }}>
            <TableHead>
              <TableRow>
                <TableCell>Field Name</TableCell>
                <TableCell>Value</TableCell>
              </TableRow>
            </TableHead>
            {this.state.selectedItemForDrawer && (
              <TableBody>
                {Array.from(Object.keys(this.state.selectedItemForDrawer)).map(
                  (key) => (
                    <TableRow
                      key={key}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        <div>
                          <Typography variant="body2">{key}</Typography>
                        </div>
                        <div>
                          <Typography variant="caption">
                            {aravindMapping[key]}
                          </Typography>
                        </div>
                      </TableCell>
                      <TableCell align="left">
                        {this.state.selectedItemForDrawer[key]}
                      </TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            )}
          </MuiTable>
        </Drawer>
        <Grid container sx={{ mb: 3 }}>
          <Grid
            item
            xs={6}
            alignItems={"start"}
            justifyContent={"start"}
            display={"flex"}
          >
            <Typography variant="h4">Data Explorer</Typography>
          </Grid>
          <Grid
            item
            xs={6}
            alignItems={"end"}
            justifyContent={"end"}
            display={"flex"}
          >
            <Button
              variant="contained"
              startIcon={<Iconify icon="ant-design:plus-outlined" />}
              onClick={this.handleAddNewItem}
              sx={{ mr: 1 }}
            >
              Enter new term
            </Button>
            <Button
              variant="contained"
              startIcon={<Iconify icon="material-symbols:download" />}
              onClick={this.handleFilterItems}
            >
              Export Output
            </Button>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          {this.state.items.map((item, index) => (
            <Grid item xs={12}>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<Iconify icon="ant-design:plus-outlined" />}
                  id={index}
                  sx={{
                    background: "white",
                    border: "1px solid #f4f4f4",
                    borderRadius: "5px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      width: "100%",
                    }}
                  >
                    {item.searchTerm.length > 0 ? (
                      <Chip
                        variant="outlined"
                        size="small"
                        icon={<Iconify icon="material-symbols-light:search" />}
                        label={item.searchTerm}
                      />
                    ) : (
                      "Enter Search Term"
                    )}
                    {item.action?.length > 0 && (
                      <Chip
                        size="small"
                        color={item.action === "INCLUDE" ? "success" : "error"}
                        label={item.action}
                      />
                    )}
                    {item.category?.length > 0 && (
                      <Chip size="small" color="info" label={item.category} />
                    )}
                    <div>
                      <div>
                        {item.selectedValues?.length > 0 && (
                          <Typography variant="subtitle1">
                            {item.selectedValues.length} selected
                          </Typography>
                        )}
                      </div>
                    </div>
                    <div
                      style={{
                        marginLeft: "auto",
                        display: "flex",
                        alignItems: "center",
                        marginRight: "10px",
                      }}
                    >
                      <IconButton
                        onClick={() => {
                          this.handleDeleteItem({ index });
                        }}
                        color="error"
                      >
                        <Iconify icon="mdi:trash" />
                      </IconButton>
                    </div>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <FormControlLabel
                    control={<TextField sx={{ width: "100%" }} />}
                    label="Search Term"
                    labelPlacement="top"
                    sx={{ textAlign: "left", alignItems: "start" }}
                    value={item.searchTerm}
                    onChange={(e) => {
                      this.handleItemChange({
                        index,
                        searchTerm: e.target.value,
                      });
                    }}
                    onBlur={(e) => {
                      if (item.searchTerm.length > 0) {
                        this.handleGetResults({ index });
                      }
                    }}
                  />
                  <Stack>
                    <FormControlLabel
                      control={
                        <Select sx={{ width: "100%" }} placeholder="Condition">
                          <MenuItem value="INCLUDE">Include</MenuItem>
                          <MenuItem value="EXCLUDE">Exclude</MenuItem>
                        </Select>
                      }
                      label="Condition"
                      labelPlacement="top"
                      sx={{ textAlign: "left", alignItems: "start" }}
                      value={item.action}
                      onChange={(e) => {
                        this.handleItemChange({
                          index,
                          action: e.target.value,
                        });
                      }}
                    />
                    <FormControlLabel
                      control={
                        <Select sx={{ width: "100%" }} placeholder="Condition">
                          <MenuItem value="HISTORY">HISTORY</MenuItem>
                          <MenuItem value="SX">SX</MenuItem>
                          <MenuItem value="FELLOW">FELLOW</MenuItem>
                        </Select>
                      }
                      label="Category"
                      labelPlacement="top"
                      sx={{ textAlign: "left", alignItems: "start" }}
                      value={item.category}
                      onChange={(e) => {
                        this.handleItemChange({
                          index,
                          category: e.target.value,
                        });
                      }}
                    />
                  </Stack>
                  {item.results?.length > 0 && (
                    <div
                      style={{ marginTop: "1rem", height: "420px" }}
                      className="virtual-results"
                    >
                      <AutoSizer>
                        {({ height, width }) => (
                          <Table
                            width={width}
                            height={400}
                            headerHeight={20}
                            rowHeight={30}
                            rowCount={item.results.length}
                            rowGetter={({ index }) => item.results[index]}
                            onRowClick={(params) => {
                              this.handleSelectRow({
                                index: index,
                                rowId: params.rowData._id,
                                rowIndex: params.index,
                              });
                            }}
                            onRowDoubleClick={(params) => {
                              this.setState({
                                selectedItemForDrawer: params.rowData,
                                openDrawer: true,
                              });
                            }}
                            rowClassName="search-table"
                          >
                            <Column
                              label="Selected"
                              dataKey="selected"
                              width={width / 5}
                              cellDataGetter={(params) => {
                                if (params.rowData.selected) return "Yes";
                                return "No";
                              }}
                              cellRenderer={(params) => (
                                <div style={{ display: "flex" }}>
                                  <IconButton
                                    color={
                                      params.rowData.selected
                                        ? "primary"
                                        : "error"
                                    }
                                  >
                                    <Iconify icon="mdi:tick" />
                                  </IconButton>
                                  <IconButton
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.handleLongSelect({
                                        index,
                                        rowIndex: params.rowIndex,
                                      });
                                    }}
                                  >
                                    <Iconify icon="mdi:tick-all" />
                                  </IconButton>
                                </div>
                              )}
                            />
                            <Column
                              width={width / 5}
                              label="SX_EYE_OBS"
                              dataKey="SX_EYE_OBS"
                            />
                            <Column
                              width={width / 5}
                              label="FELLOW_EYE_OBS"
                              dataKey="FELLOW_EYE_OBS"
                            />
                            <Column
                              width={width / 5}
                              label="SX_EYE_REMARKS"
                              dataKey="SX_EYE_REMARKS"
                            />
                            <Column
                              width={width / 5}
                              label="FELLOW_EYE_REMARKS"
                              dataKey="FELLOW_EYE_REMARKS"
                            />
                          </Table>
                        )}
                      </AutoSizer>
                    </div>
                  )}
                </AccordionDetails>
              </Accordion>
            </Grid>
          ))}
        </Grid>
      </Container>
    );
  }
}

export default WithAPICall(ADataExplorer);
